import a from './link'

const renderers = {
  a,
}

export default renderers
